export default __webpack_public_path__ + "static/media/VAIA Technologies.435134a0.png";